import { gql } from '@apollo/client';
export const MACRO_FIELDS = gql `
  fragment MacroFields on Macro {
    id
    category
    title
    content
    isGeneric
    tags
    clients {
      id
      name
    }
    clientIds
    createdAt
    updatedAt
  }
`;
export const MACROS = gql `
  ${MACRO_FIELDS}
  query MACROS($spec: MacroSpec!) {
    macros(spec: $spec) {
      total
      page
      pageSize
      items {
        ...MacroFields
      }
    }
  }
`;
export const SAVE_MACRO = gql `
  mutation SAVE_MACRO($input: MacroInput!) {
    saveMacro(input: $input) {
      success
      messages {
        value
        type
        params
      }
    }
  }
`;
export const DELETE_MACRO = gql `
  mutation DELETE_MACRO($id: Int!) {
    deleteMacro(id: $id) {
      id
    }
  }
`;
